import { getToken, getUser } from "../../Utilities/Common";
import { getWithParamsAPICall, postAPICallwithFile } from "../axiosMethodCall";

export const getFollowUpPatients = async (params) => {
    try {
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "followups/get",
            {
                requester: getUser(),
                token: getToken(),
                ...params
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response}
    }
}

export const cancelSchedule = async (followup_id) => {
    try{
        var formData = new FormData();
        formData.append("requester", getUser());
        formData.append("token", getToken());
        formData.append("followup_id", followup_id);

        const response = await postAPICallwithFile(process.env.REACT_APP_LINK + 'followups/delete',
            formData
        );

        return {data: response.data};  
    }catch (error) {
        return {error: error.response};
    }
}

export const updateSchedule = async (params) => {
    try{
        var formData = new FormData();
        formData.append("requester", getUser());
        formData.append("token", getToken());
        formData.append("followup_id", params.followup_id);
        formData.append("patient_id", params.patient_id);
        formData.append("scheduled_on", params.scheduled_on);
        formData.append("doctor_id", params.doctor_id || "");

        const response = await postAPICallwithFile(process.env.REACT_APP_LINK + 'followups/update',
            formData
        );

        return {data: response.data};  
    }catch (error) {
        return {error: error.response};
    }
}

export const createSchedule = async (params) => {
    try{
        var formData = new FormData();
        formData.append("requester", getUser());
        formData.append("token", getToken());
        formData.append("patient_id", params.patient_id);
        formData.append("scheduled_on", params.scheduled_on);
        formData.append("doctor_id", params.doctor_id || "");

        const response = await postAPICallwithFile(process.env.REACT_APP_LINK + 'followups/create',
            formData
        );

        return {data: response.data};  
    }catch (error) {
        return {error: error.response};
    }
}